<template>
  <div class="wizard">
    <ul role="tablist">
      <li
        role="tab"
        v-for="index in parseInt(steps)"
        :key="index"
        :class="{
          passed: index < step,
        }"
      >
        <span :class="{ current: index == step, completed: index < step }">{{
          index
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "WizardSteps",
  props: {
    step: Number,
    steps: Number,
  },
};
</script>

<style scoped>
.wizard ul {
  list-style: none;
  padding-top: 15px;
  min-width: 100px;
}

.wizard ul li {
  padding: 40px 0;
  position: relative;
}

.wizard ul li span {
  border-radius: 50%;
  /*  border: 1px solid black;*/
  padding: 15px 20px;
  margin-right: 10px;
  background: lightgray;
  font-weight: bolder;
  color: white;
}

.wizard .current {
  background: #07d7f7;
}

.wizard .completed {
  background: rgb(95, 201, 120);
}

.wizard ul li span:before {
  content: "";
  position: absolute;
  border-left: 4px solid;
  left: 22px;
  bottom: 0;
  z-index: -1;
  height: 100%;
}

.wizard ul li span:after,
.wizard ul li span:before {
  content: "";
  color: lightgray;
  position: absolute;
  border-left: 4px solid;
  left: 22px;
  bottom: 0;
  z-index: -1;
  height: 100%;
}

.wizard ul li span.completed:before,
.wizard ul li span.completed:after {
    color: rgb(95, 201, 120);
}

.wizard ul li span.current:before,
.wizard ul li span.current:after {
    color: #07d7f7;
}

.wizard ul li:last-child span:after {
  content: none;
}

.wizard ul li:first-child span:before {
  content: none;
}

.wizard ul li:first-child {
  padding-top: 0;
}

.wizard ul li:last-child {
  padding-bottom: 0;
}
</style>
